module.exports = __webpack_public_path__ + "img/primal-thumbnail.e35a4d66.png";